'use strict'

require 'groupon-gig/src/gig'



// WEBPACK FOOTER //
// ./core/frontend/gig-vGIG_VER.coffee